import { Box } from '@mui/material'
import PropTypes from 'prop-types'

import { useProductDetails } from '@/common/hooks'

const classes = {
    root: {
        height: 128,
        objectFit: 'contain',
        px: 2,
        py: 1,
    },
}

/**
 * App logo component that displays the correct branding logo
 *
 * Waits for Split.io feature flags to load before rendering to prevent
 * showing the wrong logo briefly. If a custom logoUrl is provided,
 * renders immediately without waiting for Split.io.
 *
 * @param {Object} props
 * @param {string} [props.logoUrl] - Custom logo URL (bypasses branding resolution)
 * @param {Function} [props.onClick] - Click handler for the logo
 * @param {Object|Array} [props.sx] - MUI sx prop for custom styling
 * @returns {React.ReactElement|null} Logo image or null while loading
 */
const AppLogo = ({ logoUrl = null, onClick = null, sx = null }) => {
    const productDetails = useProductDetails()

    // If using default logo (no custom logoUrl), wait for branding to resolve
    // This prevents flashing the wrong logo while Split.io loads
    if (!logoUrl && !productDetails.isReady) {
        return null
    }

    const logoUrlToUse = logoUrl || productDetails.logo

    return (
        <Box
            alt="[Logo Image]"
            component="img"
            src={logoUrlToUse}
            sx={[classes.root, ...(Array.isArray(sx) ? sx : [sx])]}
            onClick={() => {
                if (onClick) {
                    onClick()
                }
            }}
        />
    )
}

AppLogo.propTypes = {
    logoUrl: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    onClick: PropTypes.func,
}

export default AppLogo
